import { TemplateFunctionsModel } from 'src/app/shared/models/template-functions';
export function templateToastPosition({
    flowwwerTemplate,
}: TemplateFunctionsModel): 'top' | 'bottom' {
    return flowwwerTemplate();
}
